import { useQuery } from '@tanstack/react-query';
import { queryKeys, uuidRegEx } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { UsersScheduleRespSuccess } from './types';

export const useGetUsersSchedule = (id?: string) => {
  const { data, error, isPending, isPlaceholderData, isFetching } = useQuery<
    UsersScheduleRespSuccess,
    ApiError
  >({
    queryKey: [...queryKeys.schedules.internal.item, id],
    queryFn: () =>
      queryFetch({
        url: `schedules/${id}`,
      }),
    placeholderData: (previousData) => previousData as UsersScheduleRespSuccess,
    enabled: Boolean(id && uuidRegEx.test(id)),
  });

  return {
    data,
    error,
    isPlaceholderData,
    isFetching,
    isLoading: isPending && Boolean(id && uuidRegEx.test(id)),
  };
};
